

const INITIAL_STATE = {
    Logs: [],
    connect: false,
    currentLogs: {
        created: 0.0,
        deviceId: 0.0,
        message: 0.0,
        type: 0.0,
        _id: 0.0,
        hubId: 0.0,
    },



    alerts: []
}
const logReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case "ADD_LOGS":
            //changed to 
            /* var oldevents = state.events;
            oldevents.push(action.payload); */


            return { ...state, currentLogs: action.payload };
        case "CONNECT":

            return { ...state, connect: true };

        case "DISCONNECT":

            return { ...state, connect: false, events: [] };
        default:
            return state
    }
}



export default logReducer